<!--
 * @Descripttion: 文件上传组件
 * @Date: 2022-04-19 20:29:38
 * @LastEditTime: 2022-12-19 15:20:43
-->
<template>
  <a-modal
    :visible="visible"
    :footer="footerConfig"
    :cancel-text="footerOps.cancelText"
    :ok-text="footerOps.okText"
    :title="title"
    :width="600"
    :destroy-on-close="true"
    @cancel="changeVisible"
    @ok="handleOk"
  >
    <div
      v-if="isUploading"
      style="text-align:center"
    >
      <!-- <a-spin size="large" /> -->
      <p style="line-height:50px;">正在上传，请耐心等待...</p>
    </div>
    <div
      class="result"
      v-else-if="isUploaded"
    >
      <img src="http://hh-oss-picture.miyapay.com/box/3d4dc3bae1dc571c1028fbc149eaeb8f.svg">
      <p class="result-title">导入完成</p>
      <p
        class="result-msg"
      >
        导入完成, 其中成功<span style="color:#16BFD5; margin: 0 4px;">{{ successCount }}</span>条，失败<span style="color:red;margin: 0 4px;">{{ failCount }}</span>条；
      </p>
      <div>
        <!-- 【导入】有成功也有失败数据 -->
        <div v-if="failCount !== 0 && successCount !== 0 &&errorUrl">
          <a-button
            style="margin-right: 8px"
            @click="handleExportErrorMsg"
          >导出失败数据</a-button>
          <!-- 有成功数据时，是否有额外操作 -->
          <slot name="successOps"/>
          <!-- <a-button
            type="primary"
            @click="handleDownLoadSuccessCode"
          >下载成功的进件码</a-button> -->
        </div>
        <!-- 【导入】全部失败 -->
        <div v-if="failCount !== 0 && successCount === 0&&errorUrl">
          <a-button
            type="primary"
            @click="handleExportErrorMsg"
          >导出失败数据</a-button>

        </div>
        <!-- 【导入】全部成功 -->
        <div v-if="failCount === 0 && successCount !== 0">
          <!-- 有成功数据时，是否有额外操作 -->
          <slot name="successOps"/>
          <!-- <a-button
            type="primary"
            @click="handleDownLoadSuccessCode"
          >下载成功的进件码</a-button> -->

        </div>
      </div>
    </div>
    <section
      class="upload-info"
      v-else-if="!isUploaded"
    >
      <a-upload-dragger
        ref="uploadRef"
        name="file"
        v-if="styleType === 'dragger'"
        :before-upload="beforeExcelUpload"
        :multiple="false"
        :show-upload-list="true"
        :file-list="fileList"
        @change="fileChange"
        :remove="handleFileRemove"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">点击或者拖拽文件到此</p>
        <div class="ant-upload-content">
          <div
            class="content-list"
            v-if="tempFileName"
          >
            <div
              class="content-item"
              v-if="tempFileName"
            >1、请点击下载<a
              @click.stop=""
              :href="tempFile"
            >{{ tempFileName }}</a>；</div>
            <div class="content-item">2、打开下载的模板，将渠道信息输入或粘贴至模板，上限 {{ maxFileCount }} 条；</div>
            <div class="content-item">3、将处理好的下载模板以xls、xlsx格式导出，最大不超过 {{ maxFileSize }} M；</div>
          </div>
          <slot v-else/>
        </div>
      </a-upload-dragger>
      <ul
        v-else
        class="tip-list"
      >
        <li>1、请点击下载<a
          :href="tempFile"
        >{{ tempFileName }}</a>；</li>
        <slot name="tipText">
          <li>2、打开下载的模板，将渠道信息输入或粘贴至模板，上限 {{ maxFileCount }} 条；</li>
          <li>3、将处理好的下载模板以xls、xlsx格式导出，最大不超过 {{ maxFileSize }} M；</li>
          <li>4、点击下方“选择文件”按钮，选择要导入的文件即可进入上传；</li>
        </slot>
        <li class="handler">
          <a-upload
            ref="uploadRef"
            name="file"
            :before-upload="beforeExcelUpload"
            :multiple="false"
            :show-upload-list="true"
            :file-list="fileList"
            @change="fileChange"
            style="display: inline-block;width: 100%"
            :remove="handleFileRemove"
          >
            <a-button
              type="primary"
              block
            > 选择文件</a-button>
          </a-upload>

        </li>
      </ul>
      
    </section>
    <slot name="content"/>
  </a-modal>
</template>
<script>
import { uploadFile, errorDataExport, getTemplateFile } from '@/apis/report';


export default {
  name: 'FileUpload',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: '60%',
    },
    title: {
      type: String,
      default: '',
    },
    maxFileSize: {
      type: Number,
      default: 2,
    },
    maxFileCount: {
      type: Number,
      default: 200,
    },
    tempKey: {
      type: String,
      default: 'channel',
    },
    tempFileName: {
      type: String,
      default: '模板文件',
    },
    // 上传文件的接口url
    uploadUrl: {
      type: String,
      default: '',
      require: true,
    },
    // 导出失败数据的接口url
    errorUrl: {
      type: String,
      default: '',
      require: true,
    },
    activityId: {
      type: String,
      default: '',
    },
    pid: {
      type: Number,
      default: undefined,
    },
    params: {
      type: Object,
      default: null,
    },
    // 样式类型，默认：选择文件，dragger：选择+拖拽文件
    styleType: {
      type: String,
      default: '',
    },
    // 是否显示footer操作按钮
    footer: {
      type: [Object, Boolean],
      default: null,
    },
    // footer操作按钮文案
    footerOps: {
      type: Object,
      default: () => ({
        cancelText: '取消',
        okText: '确定',
      }),
    },
    // 是否自定footer操作按钮点击后的事件
    footerCustom: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.getTemplateFile();
      }
    },
  },
  computed: {
    // 是否显示footer，null: 不显示footer，非null：显示footer
    footerConfig() {
      let val = null;
      if (this.footer !== null) {
        val = undefined;
      }
      return val;
    },
  },
  data() {
    return {
      isUploading: false,
      uploadSucc: false,
      errorMsgFile: '',
      failList: [],
      failCount: 0, // 失败条数
      successCount: 0, // 成功行数
      failResultUrl: '',
      tableData: [],
      fileList: [],
      isUploaded: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tempFile: '', // 模板文件
      resultInfo: {}, // 文件上传后的结果
    };
  },
  methods: {
    // 获取下载模板文件
    getTemplateFile() {
      getTemplateFile({
        key: this.tempKey,
      }).then((res) => {
        this.tempFile = res.url;
      });
    },
    reset() {
      this.isUploading = false;
      this.uploadSucc = false;
      this.errorMsgFile = '';
      this.failCount = 0;
      this.successCount = 0;
      this.failList = [];
      this.fileList = [];
      this.isUploaded = false;
      this.resultInfo = {};
    },
    // 点击确定按钮
    handleOk() {
      if (this.footerCustom) {
        this.$emit('handleOk', this.resultInfo);
      } else {
        this.changeVisible();
      }
    },
    changeVisible() {
      if (this.isUploading) {
        this.$message.error('正在上传文件中，请不要中断文件上传');
      } else {
        this.$emit('update:visible', false);
        this.$emit('close');
        this.reset();
      }
    },
    // 文件下载
    downLoadFunc(src, filename, type) {
      const blobType = type === 'zip' ? 'application/zip' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
      const blob = new Blob([src], { type: blobType });
      const href = window.URL.createObjectURL(blob); // 创建下载的链接
      const a = document.createElement('a');
      a.download = filename;
      a.href = href;
      document.body.appendChild(a);
      a.click(); // 下载
      URL.revokeObjectURL(a.href); // 释放URL 对象
      document.body.removeChild(a); // 删除 a 标签
    },
    // async handleDownLoadSuccessCode() {
    //   const res = await exportSuccessCode({ isAll: false, uidList: this.successList });
    //   this.downLoadFunc(res.data, '进件码', 'zip');
    // },
    // 导出失败数据
    async handleExportErrorMsg() {
      if (this.failResultUrl) {
        window.location.href = this.failResultUrl;
      } else if (this.pid) {
        const res = await errorDataExport(this.errorUrl, { failResponseList: this.failList });
        this.downLoadFunc(res.data, '失败数据', 'excel');
      } else {
        // console.log('this.failList>>', this.failList);
        const res = await errorDataExport(this.errorUrl, this.failList);
        this.downLoadFunc(res.data, '失败数据', 'excel');
      }
    },
    // 文件上传前进行规则校验
    beforeExcelUpload(file) {
      return new Promise((resolve, reject) => {
        const size = file.size / 1024 / 1024;
        if (size > this.maxFileSize) {
          this.fileList.pop();
          this.$message.error(`文件最大不超过${this.maxFileSize}M`);
          reject(new Error('文件大小不符合要求'));
          return;
        }
        // let typeList = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"]
        // if(typeList.indexOf(file.type)!= -1){
        const that = this;
        const suffix = file.name.substr(file.name.lastIndexOf('.'));
        if (suffix === '.xls' || suffix === '.xlsx') {
          const form = new FormData(); // FormData 对象
          form.append('file', file);
          if (this.activityId) {
            form.append('activityId', this.activityId);
          }
          if (this.pid) {
            form.append('pid', this.pid);
          }
          // if (this.params) {
          //   for (const key in this.params) {
          //     form.append(key, this.params[key]);
          //   }
          // }
          // const process = (progressEvent) => {
          //   const percentNum = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          //   console.log('percentNum----->', percentNum);
          //   // this.$refs.uploadRef.onProgress(
          //   //   {
          //   //     percent: percentNum,
          //   //   },
          //   //   file,
          //   // );
          // };
          this.isUploading = true;
          uploadFile(this.uploadUrl, form, process).then((res) => {
            file.status = 'done';
            // this.$refs.uploadRef.onSuccess(res, file, '');
            if (res) {
              this.resultInfo = res;
              this.isUploading = false;
              this.isUploaded = true;
              this.uploadSucc = true;
              const {
                uidList = [], importStoreChannelsFailVOS = [], failResponseList = [], failNum, successNum, failCount, successCount, failResultUrl,
              } = res;
              if (this.pid || this.params) {
                that.failList = failResponseList;
              } else {
                that.failList = importStoreChannelsFailVOS;
              }

              that.successList = uidList;
              const urlList = ['/unioncenter/auth/storeChannelSalesman/importStoreChannels', '/unioncenter/auth/storeChannelSalesman/import-to-create-channel-account'];
              if (this.activityId) {
                that.successCount = successCount;
                that.failCount = failCount;
              } else if (urlList.includes(this.uploadUrl)) {
                that.successCount = successCount;
                that.failCount = failCount;
                that.failResultUrl = failResultUrl || '';
              } else {
                that.successCount = successNum || successCount;
                that.failCount = failNum || failCount;
              }
              if (this.pid || this.params) {
                this.$emit('successCallback', successNum, that.failList);
              } else if (this.activityId) {
                this.$emit('successCallback', that.successCount, importStoreChannelsFailVOS, failCount);
              } else {
                this.$emit('successCallback', uidList, importStoreChannelsFailVOS);
              }
            } else {
              this.$message.info('上传中，如有上传失败则在通知查看！');
              this.reset();
              this.$emit('update:visible', false);
            }
            //   this.errorMsgFile = failUrl;
          }).catch((err) => {
            this.isUploading = false;
            this.isUploaded = false;
            this.uploadSucc = false;
            this.uploadFailMsg = err;
            this.$message.error(err.message || '上传失败！');
            // window.console.error(err);
          });
        } else {
          this.fileList.pop();
          this.$message.error('请上传 .xls .xlsx 格式的文件');
          reject(new Error('文件格式不符合要求'));
        }
      });
    },
    fileChange({ file }) {
      const suffix = file.name.substr(file.name.lastIndexOf('.'));
      if (!file.stop) {
        this.fileList = [];
        if (suffix === '.xls' || suffix === '.xlsx') {
          this.fileList.push(file);
        }
      }
    },
    handleFileRemove() {
      // console.log(e);
      this.fileList.pop();
    },

  },
};
</script>
<style lang="less" scoped>
.result {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .result-title {
        font-weight: 500;
        margin-top: 8px;
    }

}
.tip-list{
  margin: 0;
  padding: 0;
  li, /deep/li {
    list-style: none;
    line-height: 24px;
    color: #222222;
    &.handler{
      margin-top: 10px;
    }
  }
}
/deep/.ant-upload.ant-upload-select{
  width: 100%;
}
.ant-upload-drag-icon {
  font-size: 35px;
  color: var(--main-color);
}
.ant-upload-text {
  font-size: 16px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.85);
}
.ant-upload-content {
  text-align: left;
  width: 100%;
  padding: 10px 40px;
  word-break: break-all;
}
.content-item {
  color: #767676;
  font-size: 14px;
}
</style>
